import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {
  isAuthenticated: boolean;
  title = 'app';
  error: Error;
  
  constructor(@Inject(OKTA_AUTH) public oktaAuth: OktaAuth,
              private oktaAuthStateService: OktaAuthStateService,
              public router: Router) {
    // Subscribe to authentication state changes
    this.oktaAuthStateService.authState$.subscribe(
    (authState) => this.isAuthenticated = authState.isAuthenticated
    );
  }  
  
  ngOnInit(): void {
    
  }

  async login() {
    try {
      await this.oktaAuth.signInWithRedirect();
    } catch (err) {
      console.error(err);
      this.error = err;
    }
  }

    async logout() {
    // Terminates the session with Okta and removes current tokens.
    await this.oktaAuth.signOut();
    this.router.navigateByUrl('/');
    }
}

